import { pillsTypes } from './pillsDefinition';
import {
  alignLeftCellStyle,
  alignRightCellStyle,
} from '@common/cellStyles';
import { CustomDecimalRenderer } from '../../shared/numeralRenderers';
import DateCellRenderer from '../../shared/agGrid/cellRenderers/dateCellRenderer.component';

import {
  glAccountColumnDefinition,
} from '../../shared/columnDefinitions';

export const fieldNames = {
  [pillsTypes.UNPOSTED_GL_JOURNALS]: 'unpostedGLJournals',
  [pillsTypes.TAX_ENTRIES_PENDING_APPROVAL]: 'pendingSubledgerUserTaxEntries',
  [pillsTypes.DECLINED_TAX_ENTRIES]: 'declinedSubledgerUserTaxEntries',
  [pillsTypes.APPROVED_TAX_ENTRIES]: 'approvedSubledgerUserTaxEntries',
};

const taxEntriesColumns = [
  {
    headerName: 'Company Code',
    field: 'companyCode',
    width: 110,
    minWidth: 120,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Tax Year',
    field: 'taxYear',
    width: 100,
    minWidth: 80,
  },
  {
    headerName: 'Country Code',
    field: 'countryCode',
    width: 180,
    minWidth: 90,
  },
  {
    headerName: 'Country Tax Type',
    field: 'countryTaxType',
    width: 180,
    minWidth: 90,
  },
  {
    headerName: 'Entry Type',
    field: 'taxEntryTypeDesc',
    width: 140,
    ...alignLeftCellStyle,
    minWidth: 130,
  },
  {
    headerName: 'Activity',
    field: 'taxEntryActivityDesc',
    width: 180,
    ...alignLeftCellStyle,
    minWidth: 180,
  },
  {
    headerName: 'Book Type',
    field: 'bookType',
    width: 60,
    minWidth: 60,
  },
  {
    headerName: 'Account',
    field: 'description',
    width: 220,
    ...alignLeftCellStyle,
    minWidth: 180,
  },
  {
    headerName: 'Tax Currency',
    field: 'currencyCode',
    width: 100,
    minWidth: 85,
  },
  {
    headerName: 'Amount',
    field: 'amount',
    width: 120,
    cellRenderer: CustomDecimalRenderer,
    ...alignRightCellStyle,
    minWidth: 100,
  },
  {
    headerName: 'Entry Date',
    field: 'createdOn',
    width: 140,
    minWidth: 125,
    cellRenderer: DateCellRenderer,
  },
  {
    headerName: 'Preparer',
    field: 'preparerName',
    width: 220,
    ...alignLeftCellStyle,
    minWidth: 120,
  },
  {
    headerName: 'Reviewer',
    field: 'reviewerName',
    width: 220,
    ...alignLeftCellStyle,
    minWidth: 120,
  },
  {
    headerName: 'Method',
    field: 'method',
    width: 80,
    ...alignLeftCellStyle,
    minWidth: 100,
  },
  {
    headerName: 'Comment',
    field: 'reviewComment',
    width: 220,
    minWidth: 150,
    ...alignLeftCellStyle,
  },
];

export const columnDefs = {
  [pillsTypes.UNPOSTED_GL_JOURNALS]: [
    {
      headerName: 'Post Date',
      field: 'postedOn',
      width: 80,
      minWidth: 80,
    },
    {
      headerName: 'Company Code',
      field: 'companyCode',
      width: 110,
      minWidth: 100,
      ...alignLeftCellStyle,
    },
    {
      ...glAccountColumnDefinition,
      headerName: 'Account',
      ...alignLeftCellStyle,
    },
    {
      headerName: 'Trading Partner',
      field: 'tradingPartner',
      width: 80,
      minWidth: 80,
    },
    {
      headerName: 'Cost Center',
      field: 'costCenter',
      width: 80,
      minWidth: 80,
    },
    {
      headerName: 'Geography',
      field: 'geography',
      width: 95,
      minWidth: 95,
    },
    {
      headerName: 'Project',
      field: 'project',
      width: 80,
      minWidth: 80,
    },
    {
      headerName: 'Reference',
      field: 'reference',
      width: 90,
      minWidth: 90,
    },
    {
      headerName: 'Book Type',
      field: 'bookType',
      width: 80,
      minWidth: 80,
    },
    {
      headerName: 'Functional Currency',
      field: 'currencyCode',
      width: 90,
      minWidth: 90,
    },
    {
      headerName: 'Entered Debit',
      field: 'debit',
      width: 100,
      cellRenderer: CustomDecimalRenderer,
      minWidth: 100,
      ...alignRightCellStyle,
    },
    {
      headerName: 'Entered Credit',
      field: 'credit',
      width: 110,
      cellRenderer: CustomDecimalRenderer,
      minWidth: 100,
      ...alignRightCellStyle,
    },
    {
      headerName: 'Account Description',
      field: 'acctDescription',
      width: 300,
      minWidth: 200,
      ...alignLeftCellStyle,
    },
  ],
  [pillsTypes.DECLINED_TAX_ENTRIES]: taxEntriesColumns,
  [pillsTypes.TAX_ENTRIES_PENDING_APPROVAL]: taxEntriesColumns,
  [pillsTypes.APPROVED_TAX_ENTRIES]: taxEntriesColumns,
};
